//
// THIS MODULE WILL ENABLE CHANGE OF OPTIONS IN SPECIALIZATION
// DEPENDING ON CUSTOMER TYPE SELECTION
//

// To use this module make sure you have const specialtyMapping defined
// in your website customisation code, inside init() {...}.
// This is how specialtyMapping should be defined:

// window.DigitalIdentityHub.getModule('CustomSpecialisationOptions').setMapping({
//   NR: [
//     {
//       value: 'X1',
//       label: 'Example Speciality 1',
//     },
//     {
//       value: 'X1',
//       label: 'Example Speciality 2',
//     }
//   ],
// });

export default class CustomSpecialisationOptions implements IDigitalIdentityHubModule {
  public name = "CustomSpecialisationOptions";

  private specialtyMapping: ISpecialtyMapping;

  private specialitySelector: HTMLSelectElement;
  private defaultOptions: string;
  private professionSelector: HTMLSelectElement;

  public setMapping = (mapping: ISpecialtyMapping) => {
    this.specialtyMapping = mapping;
  };

  public getMapping = () => {
    return this.specialtyMapping;
  };

  public init() { /* No functionality */ }

  public ready() {
    if (!this.specialtyMapping) {
      return;
    }

    console.log("module ready");
    // Registration page has been initiated
    janrain.events.onCaptureRegistrationStart.addHandler(result => {
      // And it's loaded (we add handler that will later be defined in a function)
      if (result.screen === "traditionalRegistration") {
        janrain.events.onCaptureRenderComplete.addHandler(alterSpecialityAccordingToProfession);
      }
    });

    // Defining the function if the Registration page has been loaded
    const alterSpecialityAccordingToProfession = () => {
      // We assign variable to selection of speciality and put to variable default options
      this.specialitySelector = document.getElementById("capture_traditionalRegistration_mainSpecialty") as HTMLSelectElement;
      this.defaultOptions = this.specialitySelector.innerHTML.replace('selected="selected"', "");

      // We assign variable to customer type selection of type of customer and add event listened => On change of selection
      this.professionSelector = document.getElementById("capture_traditionalRegistration_customerType") as HTMLSelectElement;
      this.professionSelector.addEventListener("change", this.switchSpecialityOptionsAccordingToProfession);
    };

    // Edit profile page has been loaded
    janrain.events.onCaptureRenderComplete.addHandler(result => {
      if (result.screen === "editProfile" && result.builtInScreenRendered === "retrievingUserData") {
        janrain.events.onCaptureRenderComplete.addHandler(() => {
          // We assign variable to selection of speciality and put to variable default options
          this.specialitySelector = document.getElementById("capture_editProfile_mainSpecialty") as HTMLSelectElement;
          this.defaultOptions = this.specialitySelector.innerHTML.replace('selected="selected"', "");

          // Let's create some rules for when user changes the customer type
          // We assign variable to customer type selection of type of customer and add event listened => On change of selection
          this.professionSelector = document.getElementById("capture_editProfile_customerType") as HTMLSelectElement;
          if (this.professionSelector) {
            this.professionSelector.addEventListener("change", this.switchSpecialityOptionsAccordingToProfession);
          }
          // Accessing user data to find out if user has matching customer type
          const userData = JSON.parse(localStorage.getItem("janrainCaptureProfileData"));

          // Check if user's specialty is existing in the mapping object, if no then just add it.
          if (this.specialtyMapping[userData.customerType]) {
            if (userData.mainSpecialty) {
              const isMainSpecialtyExistInMapping = this.specialtyMapping[userData.customerType]
                .filter(item=> item.value === userData.mainSpecialty ? item : undefined);

              // When user's specialty is not available in mapping
              if (isMainSpecialtyExistInMapping.length === 0) {
                const label = this.getMainSpecialtyTextFromValue(result.screen, userData.mainSpecialty);
                this.specialtyMapping[userData.customerType].push({
                  value: userData.mainSpecialty,
                  label
                });
              }
            }

            // For each value of the mapping array we add new option to the variable
            this.remap(this.specialtyMapping[userData.customerType], userData.mainSpecialty);
          }
        });
      }
    });
  }

  private switchSpecialityOptionsAccordingToProfession = () => {
    // Putting to variable current selection
    const optionSelectedByUser = this.professionSelector.options[this.professionSelector.selectedIndex].value;

    // Checking if current selection matches something in the mapping
    if (this.specialtyMapping[optionSelectedByUser]) {
      // For each value of the mapping array we add new option to the variable
      this.remap(this.specialtyMapping[optionSelectedByUser]);
    } else {
      // If nothing will match in the mapping we will assign the default options
      this.specialitySelector.innerHTML = this.defaultOptions;
    }
  };

  private remap = (mapping, mainSpecialty = null) => {
    this.specialitySelector.innerHTML = "";

    mapping.forEach(item => {
      const newOptionValue = item.value;
      const newOptionText = item.label;
      let disabled = newOptionValue == "" ? "disabled" : "";
      if (disabled != "" && mainSpecialty == null) {
        disabled += " selected='selected'";
      }
      if (mainSpecialty && newOptionValue === mainSpecialty) {
        const newOption = "<option selected " + disabled + " value='" + newOptionValue + "'>" + newOptionText + "</option>";
        this.specialitySelector.innerHTML += newOption;
      } else {
        const newOption = "<option " + disabled + " value='" + newOptionValue + "'>" + newOptionText + "</option>";
        this.specialitySelector.innerHTML += newOption;
      }
    });
  };

  // get main specialty label from the form's drop-down list, if no then use value as label.
  private getMainSpecialtyTextFromValue = (screen, mainSpecialtyValue) : string => {
    const mainSpecialtyField = document.getElementById(`capture_${screen}_mainSpecialty`) as HTMLSelectElement;

    if (mainSpecialtyField) {
      Array.from(mainSpecialtyField.options).forEach(e=>{
        if (e.value === mainSpecialtyValue) {
          return e.innerText;
        }
      });
    }

    return mainSpecialtyValue;
  };
}
